<template>
  <div>
    <DynamicModal
      :showModal="showModalProp"
      :persistent="false"
      @clickOutside="closeModal"
      :title="`Work Log - ${consultant}`"
      maxWidth="1200px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeModal"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <div class="mt-3">
          <v-row>
            <v-col cols="12" class="px-4" v-if="!readonly">
              <span class="headline">
                <small>
                  Clock Out Was Not Recorded
                  <div class="red-square"></div>
                </small>
              </span>
              <span class="headline ml-5">
                <small>
                  Adjusted
                  <div class="blue-square"></div>
                </small>
              </span>
              <span class="headline ml-5">
                <small>
                  Ok
                  <div class="white-square"></div>
                </small>
              </span>
            </v-col>
            <v-col cols="12" class="px-4" v-if="readonly">
              <span class="headline">
                <small>
                  Uploaded to Time Card
                  <div class="green-square"></div>
                </small>
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4"
              style="min-height: 350px; max-height: 350px;"
              v-for="day in clockDaysLogValue" :key="day.staffLynxLocalDateTime"
            >
              <ClockDayLogDetails
                :dayLog="day"
                :readonly="readonly"
                @showGelocationDetails="() => { showModalProp = false }"
                @closeGeolocationDetails="showModal"
                @showEditTimeModal="() => { showModalProp = false }"
                @closeTimeEdit="showModal"
                @totalTimeChanged="totalTimeChangedHandler"
              ></ClockDayLogDetails>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <div class="row d-flex justify-end">
          <div class="col-6" v-if="!readonly">
            <v-btn
              block
              depressed
              color="primary"
              @click="save"
            >
              Save To Time Management
            </v-btn>
          </div>
          <div :class="readonly ? 'col-12' : 'col-6'">
            <v-btn
              block
              depressed
              outlined
              @click="closeModal"
            >
              {{ readonly ? 'close' : 'cancel' }}
            </v-btn>
          </div>
        </div>
      </v-container>
    </DynamicModal>
    <MessageBox
      ref="messageBox"
      :message="messageBoxText"
      color="error"
      closeTextColor="white"
    ></MessageBox>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import ClockDayLogDetails from './ClockDayLogDetails'
import { mapActions } from 'vuex'
import { OK, ERROR, UPLOADED_TO_TIME_SHEET_ENTRIES } from '@/lib/constants/clockLogStates'
import { MessageBox } from '@/components/shared/messages'

export default {
  components: {
    DynamicModal,
    ClockDayLogDetails,
    MessageBox
  },
  data () {
    return {
      OK,
      ERROR,
      UPLOADED_TO_TIME_SHEET_ENTRIES,
      showModalProp: false,
      consultant: null,
      consultantUserId: null,
      weekLog: [],
      editedClockDaysLog: [],
      messageBoxText: null
    }
  },
  computed: {
    clockDaysLogValue: {
      get () {
        let daysLogToShow = []
        for (let day of this.weekLog) {
          let filteringResult = this.editedClockDaysLog.filter(log => log.staffLynxLocalDateTime === day.staffLynxLocalDateTime)
          if (filteringResult && filteringResult.length > 0) {
            daysLogToShow.push(filteringResult[0])
          } else {
            daysLogToShow.push(day)
          }
        }
        return daysLogToShow
      }
    },
    readonly () {
      return !this.weekLog.some(day => day.state !== this.UPLOADED_TO_TIME_SHEET_ENTRIES)
    }
  },
  methods: {
    ...mapActions('clockLogsReport', [
      'saveClockApprovedLogs'
    ]),
    totalTimeChangedHandler (dayLog) {
      let result = this.editedClockDaysLog.filter(log => log.staffLynxLocalDateTime === dayLog.staffLynxLocalDateTime)
      if (result && result.length > 0) {
        result[0].workedTime = dayLog.workedTime
        result[0].details = dayLog.details
      } else {
        this.editedClockDaysLog.push(dayLog)
      }
    },
    async save () {
      let logsWithErrors = this.clockDaysLogValue.filter(log => log.state === this.ERROR)
      if (logsWithErrors && logsWithErrors.length > 0) {
        this.messageBoxText = 'There are still logs without Clock Out time in the work log. Please adjust them before saving.'
        this.$refs.messageBox.show()
      } else {
        let workLogsToApprove = this.editedClockDaysLog.map(log => {
          return {
            assignmentId: log.assignmentId,
            staffLynxDate: log.staffLynxLocalDateTime,
            workedHours: log.workedTime,
            details: log.details
          }
        })
        let timesheetEntries = this.clockDaysLogValue.map(log => {
          return {
            assignmentId: log.assignmentId,
            userId: this.consultantUserId,
            date: log.staffLynxLocalDateTime,
            hours: log.workedTime
          }
        })
        let payLoad = { approvedLogs: workLogsToApprove, timesheetEntries: timesheetEntries }
        await this.saveClockApprovedLogs(payLoad)
        this.$emit('timeUploadedToTimeCard')
        this.closeModal()
      }
    },
    showModal (consultant, consultantUserId, weekLog) {
      if (consultant !== null && consultant !== undefined) {
        this.consultant = consultant
      }
      if (consultantUserId !== null && consultantUserId !== undefined) {
        this.consultantUserId = consultantUserId
      }
      if (weekLog) {
        this.weekLog = JSON.parse(JSON.stringify(weekLog))
      }
      this.showModalProp = true
    },
    closeModal () {
      this.showModalProp = false
      this.consultant = null
      this.consultantUserId = null
      this.weekLog = []
      this.editedClockDaysLog = []
    }
  }
}
</script>
